/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["playing-indicator{display:block;width:20px;height:20px}playing-indicator>.mat-icon{display:block;width:inherit;height:inherit}"];
export { styles as styles };
